import axios from "axios";
import { ForgotPasswordURLs } from '../constants/url';


  export const EmailSend = ( body) =>
  axios({
    url: `${ForgotPasswordURLs.url}`,
    method: "Post",
    data:body,
});